import { townsperson } from './content.js';
import { DESERT_CAMEL_QUESTS } from './desert-camels.js';
import { DESERT_CHAIN_START } from './desert-chain-1.js';
import { DESERT_CHAIN_END } from './desert-chain-2.js';
import { DESERT_DRAGON_QUESTS } from './desert-dragon.js';
/**
 * The quests of the Désert de Braise (ADR 0047): the chain that starts with
 * Maître Kassim (`caravan-master`), on the square of Sablerouge. His lost
 * caravan leads to the tracker Zahra by the Hyenas' Cave, the scribe Néfer
 * at the Forgotten Obelisk, the Forgotten Pharaoh's stolen mask, then the
 * priestess Méret at the Jackal's Temple and its golden guardian, and north
 * to Givrecime. After the Jackal, the dragon's mark by the Obelisk and Méret's
 * recruitment to the Company (`desert-dragon.ts`, ADR 0067). See `content.ts`.
 */
/** The townsfolk only this region's quests need, added to the bestiary. */
export const DESERT_NPC_IDS = [
    'caravan-master',
    'dune-tracker',
    'desert-scribe',
    'jackal-priestess',
];
export const DESERT = {
    quests: [
        ...DESERT_CHAIN_START,
        ...DESERT_CAMEL_QUESTS,
        ...DESERT_CHAIN_END,
        ...DESERT_DRAGON_QUESTS,
    ],
    npcs: {
        'caravan-master': townsperson('caravan-master', 'Maître Kassim'),
        'dune-tracker': townsperson('dune-tracker', 'Traqueuse Zahra'),
        'desert-scribe': townsperson('desert-scribe', 'Scribe Néfer'),
        'jackal-priestess': townsperson('jackal-priestess', 'Prêtresse Méret'),
    },
    // Kassim stands on the square of Sablerouge, placed by the generator.
    keepers: [
        { mob: 'dune-tracker', near: 'Grotte des Hyènes', dx: -3, dy: 4 },
        { mob: 'desert-scribe', near: 'Obélisque Oublié', dx: 2, dy: 3 },
        { mob: 'jackal-priestess', near: 'Temple du Chacal', dx: -4, dy: 4 },
        // Each player's own quarry on the Plaine de verre (ADR 0087): no den lies near it.
        {
            mob: 'ember-salamander',
            near: 'La Plaine de verre',
            dx: 0,
            dy: 0,
            count: 5,
            radius: 5,
            during: 'desert-glass',
        },
    ],
    items: [
        {
            id: 'hyena-bait',
            name: 'Carcasse faisandée',
            kind: 'consumable',
            maxStack: 1,
            icon: 'icon.hyena-bait',
            lootable: false,
            bait: { summons: 'mangy-hyena', den: 'hyena' },
        },
        {
            id: 'funeral-incense',
            name: 'Encens funéraire',
            kind: 'consumable',
            maxStack: 1,
            icon: 'icon.funeral-incense',
            lootable: false,
            bait: { summons: 'cursed-mummy', den: 'mummy' },
        },
        {
            id: 'royal-cartouche',
            name: 'Cartouche royal',
            kind: 'consumable',
            maxStack: 1,
            icon: 'icon.royal-cartouche',
            lootable: false,
            bait: { summons: 'forgotten-pharaoh', den: 'mummy' },
        },
    ],
    // The chain pays about half the band (`quests.test.ts`), so the desert's
    // creatures pay a little under half what they did before it (lowered again
    // for the dragon's quests, ADR 0067): with the chain, the desert takes no
    // less time than hunting alone did (ADR 0047, `audit:pacing`).
    xp: {
        hyena: 30,
        scorpion: 32,
        cobra: 31,
        mummy: 34,
        'ember-salamander': 38,
    },
    greetings: {
        'camel-driver': 'Doucement, doucement… Non, pas toi, je parlais à Safran.',
        'caravan-master': 'D’habitude, j’ai onze caravanes par saison. Cette année, dix. Ne me parle pas de la onzième.',
        'dune-tracker': 'Le vent a tourné. Demain, toutes les traces auront disparu.',
        'desert-scribe': 'Ne touche pas l’Obélisque avec tes doigts, tu vas laisser des traces de gras !',
        'jackal-priestess': 'Un brasero s’est éteint une fois. Une seule ! Et on ne m’y reprendra plus.',
    },
};
//# sourceMappingURL=desert.js.map